import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinPageContentFrame } from '../../components/ClinPageContentFrame'
import { BasicSearch } from '../../features/Search/BasicSearch'

export const StyledProgramsSearchHeader = styled.div({
  display: 'flex',
  fontFamily: ClinTheme.fonts.groteskRegular,
  alignItems: 'center',
  padding: '24px 0'
})

export const StyledPageTitle = styled.div({
  fontFamily: ClinTheme.fonts.groteskExtraBold,
  fontSize: '32px',
  fontWeight: ClinTheme.fontWeights.bolder,
  marginRight: '8px'
})
export const StyledTooltip = styled.div({
  marginRight: '25px',
  '& > div': {
    display: 'flex !important',
    alignItems: 'center'
  }
})
export const StyledPageHeader = styled.div({
  backgroundColor: ClinTheme.colors.white
})

export const ProgramsPageContent = styled.div({
  backgroundColor: ClinTheme.colors.lightGrey
})

export const StyledHeaderClinPageContentFrame = styled(ClinPageContentFrame)({
  marginBottom: '0px !important'
})

export const StyledBasicSearch = styled(BasicSearch)({
  width: '100%',
  maxWidth: '565px',
  '& > input': {
    borderRadius: '20px',
    color: ClinTheme.colors.black
  }
})
